import { render, staticRenderFns } from "./SelectPrescriptionForm.vue?vue&type=template&id=9dd21b72&scoped=true"
import script from "./SelectPrescriptionForm.vue?vue&type=script&lang=js"
export * from "./SelectPrescriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd21b72",
  null
  
)

export default component.exports